import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { SIGN_STATUS } from '../../commons/digitalSignature/DigitalSignatureStatus';
import { ErrorMessage } from '../../commons/form-fields/ErrorMessage';
import { SubmitTaxDocumentViaDigitalSignatureButton } from '../digitalSignature/SubmitTaxDocumentViaDigitalSignatureButton';

const SubmitTaxDocumentViaDigitalSignatureField = (props) => {
    const { fieldName, taxDocumentLabel, handleBeforeAdobeSign, required } =
        props;

    const _validateSubmitField = (value) =>
        !required || value === SIGN_STATUS.SIGNED
            ? undefined
            : `Please fill ${taxDocumentLabel} using Adobe Sign`;

    return (
        <Field name={fieldName} validate={_validateSubmitField}>
            {({ input: { onChange }, meta }) => (
                <div>
                    <div>
                        <SubmitTaxDocumentViaDigitalSignatureButton
                            onStatusChange={onChange}
                            taxDocumentLabel={taxDocumentLabel}
                            handleBeforeAdobeSign={handleBeforeAdobeSign}
                        />
                    </div>
                    <ErrorMessage meta={meta} />
                </div>
            )}
        </Field>
    );
};

SubmitTaxDocumentViaDigitalSignatureField.propTypes = {
    taxDocumentLabel: PropTypes.string,
    fieldName: PropTypes.string,
    handleBeforeAdobeSign: PropTypes.func,
    required: PropTypes.bool,
};

const ConsultantInvoiceTaxDocumentDigitalSignatureSection = (props) => {
    const { required = true } = props;

    return (
        <div>
            <h2
                className="text-center text-blue-700 font-semibold text-xl"
                data-testid="tax-document-section-title"
            >
                Tax Document Section
                {!required && (
                    <span className="text-gray-500 font-normal">
                        {' '}
                        <i>(Optional)</i>
                    </span>
                )}
            </h2>
            <div className="w-full my-6 py-4 overflow-hidden bg-white rounded border border-gray-200">
                <div className="px-4">
                    <SubmitTaxDocumentViaDigitalSignatureField
                        {...props}
                        fieldName="invoiceTaxDocument"
                    />
                </div>
            </div>
        </div>
    );
};

ConsultantInvoiceTaxDocumentDigitalSignatureSection.propTypes = {
    taxDocumentLabel: PropTypes.string,
    handleBeforeAdobeSign: PropTypes.func,
    required: PropTypes.bool,
};

export default ConsultantInvoiceTaxDocumentDigitalSignatureSection;
